import { render, staticRenderFns } from "./TheKanban.vue?vue&type=template&id=4f4c5b5f&"
import script from "./TheKanban.vue?vue&type=script&lang=js&"
export * from "./TheKanban.vue?vue&type=script&lang=js&"
import style0 from "./TheKanban.vue?vue&type=style&index=0&id=4f4c5b5f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports